export const fbTrack = (event, data) => {
  if (window.fbq) window.fbq("track", event, data);
};

export const fbPageView = () => {
  if (window.fbq) window.fbq("track", "PageView");
};
